import { render, staticRenderFns } from "./ClientHeaderDetails.vue?vue&type=template&id=426fb706&scoped=true&"
import script from "./ClientHeaderDetails.vue?vue&type=script&lang=js&"
export * from "./ClientHeaderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426fb706",
  null
  
)

export default component.exports